import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import PropTypes from "prop-types";
import ContentSider from "../../../components/templates/ContentSider";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
// import SubMenu from "../../../components/templates/SubMenu";
import { AuditOutlined } from "@ant-design/icons";
import SystemTable from "../../../components/templates/SystemTable";
import Holidays from "./holidays/Holidays";
import {
  MetaDataSelect,
  BranchSelect,
  SettingsDataSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import { UsersSelect } from "../../../components/forms/AutoCompleteFormItem";

import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import {
  listBranches,
  getSystemTable,
  getReferrerTypes,
  listUsers,
} from "../../../api/server";
import { isAllowedFeature } from "../../organization/organizationSlice";
import {
  SolutionOutlined,
  FilePdfOutlined,
  DollarCircleOutlined,
  FlagOutlined,
  SettingOutlined,
  ContainerOutlined,
  RocketOutlined,
  MedicineBoxOutlined,
  DashboardOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

import _ from "lodash";
import { useIntl } from "react-intl";
const { Content } = Layout;
const groupBy = require("lodash/groupBy");
const { SubMenu } = Menu;

const SystemTables = (props) => {
  const { activekey } = props;
  const [menuKey, setMenuKey] = useState("education");
  const [list, setList] = useState([]);
  const [referrerList, setReferrerList] = useState([]);
  const [referrerTypesList, setReferreTypesList] = useState([]);

  const intl = useIntl();

  const onMenuSelect = ({ key }) => {
    setMenuKey(key);
  };

  const onClick = ({ key }) => {
    setMenuKey(key);
  };

  useEffect(() => {
    if (menuKey === "branch_extensions" || menuKey === "sub_referrer") {
      listBranches({ current: 1, pageSize: 100 }).then(({ error, data }) => {
        if (data) {
          setList(data.items);
        } else {
          setList([]);
        }
      });
    }
    if (menuKey === "client_category") {
      getSystemTable("order_service_types").then(({ error, data }) => {
        if (data) {
          setList(data.items);
        } else {
          setList([]);
        }
      });
    } else if (menuKey === "asset_sub_categories") {
      getSystemTable("asset_categories").then(({ error, data }) => {
        if (data) {
          setList(data.items);
        } else {
          setList([]);
        }
      });
    }

    if (menuKey === "referrer") {
      getReferrerTypes().then(({ error, data }) => {
        if (data) {
          setReferreTypesList([]);

          // setReferreTypesList(data.items);
        } else {
          setReferreTypesList([]);
        }
      });
    }

    if (menuKey === "sub_referrer") {
      getSystemTable("referrer").then(({ error, data }) => {
        if (data) {
          setReferrerList(data.items);
        } else {
          setReferrerList([]);
        }
      });
    }

    if (menuKey === "branch_groups") {
      getSystemTable("branch_groups").then(({ error, data }) => {
        if (data) {
          const result = data.items.reduce((acc, item) => {
            if (item.manager_user !== null) {
              acc.push(item.manager_user);
            }
            return acc;
          }, []);
          setList(result);
        } else {
          setList([]);
        }
      });
    }
  }, [menuKey]);

  const filterOrderServiceTypes = (items) => {
    const isAllowed = isAllowedFeature("supporting_community");
    // If isAllowed is not true, filter out items with supporting_community = true
    if (!isAllowed) {
      return items.filter((item) => !item.supporting_community);
    }
    // else, return the original items
    return items;
  };

  const ownerTypeData = [
    {
      value: "patients",
      name: intl.formatMessage({
        id: `app.sidebar.patients`,
      }),
    },
    {
      value: "employees",
      name: intl.formatMessage({
        id: `app.sidebar.employees`,
      }),
    },
  ];

  const entityData = [
    {
      value: "patient",
      name: intl.formatMessage({
        id: `app.sidebar.patients`,
      }),
    },
    {
      value: "employee",
      name: intl.formatMessage({
        id: `app.sidebar.employees`,
      }),
    },
  ];

  const absenceReasonsTypeData = [
    {
      value: 1,
      name: intl.formatMessage({
        id: `app.settings.system_tables.vacation`,
      }),
    },
    {
      value: 2,
      name: intl.formatMessage({
        id: `app.settings.system_tables.sickness`,
      }),
    },
    {
      value: 3,
      name: intl.formatMessage({
        id: `app.settings.system_tables.miluim`,
      }),
    },
    {
      value: 4,
      name: intl.formatMessage({
        id: `app.settings.system_tables.mourning_days`,
      }),
    },
  ];

  const daysData = [
    {
      value: 0,
      name: intl.formatMessage({
        id: `app.forms.sunday`,
      }),
    },
    {
      value: 1,
      name: intl.formatMessage({
        id: `app.forms.monday`,
      }),
    },
    {
      value: 2,
      name: intl.formatMessage({
        id: `app.forms.tuesday`,
      }),
    },
    {
      value: 3,
      name: intl.formatMessage({
        id: `app.forms.wednesday`,
      }),
    },
    {
      value: 4,
      name: intl.formatMessage({
        id: `app.forms.thursday`,
      }),
    },
    {
      value: 5,
      name: intl.formatMessage({
        id: `app.forms.friday`,
      }),
    },
    {
      value: 6,
      name: intl.formatMessage({
        id: `app.forms.satuarday`,
      }),
    },
  ];

  let ActiveComponent = null;
  switch (menuKey) {
    case "education":
      ActiveComponent = () => (
        <SystemTable
          source="education"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;

    case "care_demands":
      ActiveComponent = () => (
        <SystemTable
          source="care_demands"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
          ]}
        />
      );
      break;
    case "patient_categories":
      ActiveComponent = () => (
        <SystemTable
          source="patient_categories"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;

    case "patient_emergeycy_service_status":
      ActiveComponent = () => (
        <SystemTable
          source="patient_emergeycy_service_status"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
          built_in_non_editable={["name", "description"]}
        />
      );
      break;

    case "relative_types":
      ActiveComponent = () => (
        <SystemTable
          source="relative_types"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;
    case "departments":
      ActiveComponent = () => (
        <SystemTable
          source="departments"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            { key: "code", required: true },
          ]}
        />
      );
      break;
    case "order_service_types":
      ActiveComponent = () => (
        <SystemTable
          source="order_service_types"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "project_tag",
              required: isAllowedFeature("accounting_tag"),
              type: "number",
              formItemRules: ["onlyPositiveNumbers", "oneToNineNumbers"],
            },
          ]}
        />
      );
      break;

    case "client_frame_symbol":
      ActiveComponent = () => (
        <SystemTable
          source="client_frame_symbol"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
          ]}
        />
      );
      break;

    case "client_tariff_symbol":
      ActiveComponent = () => (
        <SystemTable
          source="client_tariff_symbol"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "service_type",
            },
            {
              key: "description",
            },
          ]}
        />
      );
      break;

    case "order_close_reason":
      ActiveComponent = () => (
        <SystemTable
          source="order_close_reason"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "active", type: "checkbox" },
          ]}
        />
      );
      break;

    case "absence_reasons":
      ActiveComponent = () => (
        <SystemTable
          source="absence_reasons"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "salary_code",
              type: "number",
              formItemRules: ["onlyPositiveNumbers"],
            },
            {
              key: "type",
              required: true,
              type: "select",
              selectData: absenceReasonsTypeData,
            },
          ]}
        />
      );
      break;

    case "company_types":
      ActiveComponent = () => (
        <SystemTable
          source="company_types"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
          ]}
        />
      );
      break;

    case "insurance_companies":
      ActiveComponent = () => (
        <SystemTable
          source="insurance_companies"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
          ]}
        />
      );
      break;

    case "languages":
      ActiveComponent = () => (
        <SystemTable
          source="languages"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
          ]}
        />
      );
      break;

    case "monthly_transportation_cost":
      ActiveComponent = () => (
        <SystemTable
          source="salary/monthly_transportation_cost"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "cost",
              type: "number",
              sorter: true,
              formItemRules: ["twoDigitsNumbers", "onlyPositiveNumbers"],
            },
          ]}
        />
      );
      break;

    case "refund_reasons":
      ActiveComponent = () => (
        <SystemTable
          source="refund_reasons"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;

    case "unpaid_hours_reasons":
      ActiveComponent = () => (
        <SystemTable
          source="unpaid_hours_reasons"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;

    case "daily_transportation_cost":
      ActiveComponent = () => (
        <SystemTable
          source="salary/daily_transportation_cost"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "cost",
              type: "number",
              sorter: true,
              formItemRules: ["twoDigitsNumbers", "onlyPositiveNumbers"],
            },
          ]}
        />
      );
      break;

    case "religions":
      ActiveComponent = () => (
        <SystemTable
          source="religions"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "rest_day",
              required: true,
              type: "select",
              selectData: daysData,
            },
          ]}
        />
      );
      break;

    case "tasks_types":
      ActiveComponent = () => (
        <SystemTable
          source="tasks_types"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;

    case "managed_gap_reasons":
      ActiveComponent = () => (
        <SystemTable
          source="managed_gap_reasons"
          fields={[
            { key: "name", focused: true, required: true },
            { key: "description" },
            { key: "hidden", type: "checkbox" },
          ]}
        />
      );
      break;

    case "report_categories":
      ActiveComponent = () => (
        <SystemTable
          source="report_categories"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
          ]}
        />
      );
      break;
    case "end_work_period_reason":
      ActiveComponent = () => (
        <SystemTable
          source="end_work_period_reason"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;
    case "courses":
      ActiveComponent = () => (
        <SystemTable
          source="courses"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "description" },
            { key: "recognized", type: "checkbox" },
          ]}
        />
      );
      break;

    case "hospitalization":
      ActiveComponent = () => (
        <SystemTable
          source="hospitalization_institutions"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "code" },
          ]}
        />
      );
      break;

    case "emergency_communication_ways":
      ActiveComponent = () => (
        <SystemTable
          source="emergency_communication_ways"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
          ]}
        />
      );
      break;

    case "referrer":
      ActiveComponent = () => (
        <SystemTable
          source="referrer"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "referrer_type",
              required: true,
              type: "formItem",
              listData: referrerTypesList,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <SettingsDataSelect
                  style={{
                    margin: 0,
                  }}
                  name="referrer_type"
                  required={true}
                  hideLabel={true}
                  category="patient"
                  settingsdataName={"referrer_types"}
                  getPopupContainer={(trigger) => document.body}
                  filterItems={(items) =>
                    items.map((item) => {
                      return {
                        name: intl.formatMessage({
                          id: `app.settings.system_tables.${item.name}`,
                        }),
                        id: item.name,
                      };
                    })
                  }
                />
              ),
            },
          ]}
        />
      );
      break;

    case "sub_referrer":
      ActiveComponent = () => (
        <SystemTable
          source="sub_referrer"
          initialSorter={"name"}
          showInput={true}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "referrer_id",
              required: true,
              type: "formItem",
              listData: referrerList,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <SettingsDataSelect
                  style={{
                    margin: 0,
                  }}
                  name="referrer_id"
                  required={true}
                  hideLabel={true}
                  category="patient"
                  settingsdataName={"system_tables/referrer"}
                  getPopupContainer={(trigger) => document.body}
                />
              ),
            },
            {
              key: "branches",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              selectMode: "multiple",
              formItem: (
                <BranchSelect
                  style={{
                    margin: 0,
                  }}
                  name="branches"
                  category="referrer"
                  required={true}
                  hideLabel={true}
                  mode={"multiple"}
                  getPopupContainer={(trigger) => document.body}
                />
              ),
            },
          ]}
        />
      );
      break;

    case "holidays":
      ActiveComponent = () => <Holidays />;
      break;

    case "subprojects":
      ActiveComponent = () => (
        <SystemTable
          source="subprojects"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
            {
              key: "number",
              type: "number",
              sorter: true,
              formItemRules: ["onlyPositiveNumbers", "oneTo999Numbers"],
            },
          ]}
        />
      );
      break;

    case "branch_extensions":
      ActiveComponent = () => (
        <SystemTable
          source="branch_extensions"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "branch_id",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <BranchSelect
                  style={{
                    margin: 0,
                  }}
                  name="branch_id"
                  category="patient"
                  required={true}
                  hideLabel={true}
                  getPopupContainer={(trigger) => document.body}
                />
              ),
            },
            {
              key: "number",
              type: "number",
              sorter: true,
              formItemRules: ["onlyPositiveNumbers", "oneToNineNumbers"],
            },
          ]}
        />
      );
      break;

    case "service_areas":
      ActiveComponent = () => (
        <SystemTable
          source="service_areas"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
          ]}
        />
      );
      break;

    case "branch_groups":
      ActiveComponent = () => (
        <SystemTable
          source="branch_groups"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
            {
              key: "manager_user_id",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <UsersSelect
                  style={{
                    margin: 0,
                    width: "100%",
                  }}
                  items={list}
                  name="manager_user_id"
                  category="referrer"
                  required={true}
                  hideLabel={true}
                  getPopupContainer={(trigger) => document.body}
                  extraParams={{ filter: { freeText: "" } }}
                />
              ),
            },
          ]}
        />
      );
      break;

    case "client_category":
      ActiveComponent = () => (
        <SystemTable
          source="client_category"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "accounting_tag",
              type: "number",
              sorter: true,
              formItemRules: ["onlyPositiveNumbers", "zeroToNinetyNineNumbers"],
            },
            {
              key: "service_types",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              selectMode: "multiple",
              formItem: (
                <MetaDataSelect
                  name="service_types"
                  category="settings"
                  metadataName="order_service_types"
                  mode="multiple"
                  hideLabel={true}
                  required={isAllowedFeature("accounting_tag")}
                  getPopupContainer={(trigger) => document.body}
                  filterItems={filterOrderServiceTypes}
                />
              ),
            },
            {
              key: "accounting_export_tag",
              formItemRules: ["fifteenCharacters"],
            },

            {
              key: "default_service_type_id",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <MetaDataSelect
                  name="default_service_type_id"
                  category="settings"
                  metadataName="order_service_types"
                  hideLabel={true}
                  required={isAllowedFeature("accounting_tag")}
                  getPopupContainer={(trigger) => document.body}
                  filterItems={filterOrderServiceTypes}
                />
              ),
            },
            { key: "group_prospectus_by_patients", type: "checkbox" },
            { key: "paid_by_patient_account", type: "checkbox" },
            { key: "prospectus_requires_approval", type: "checkbox" },
          ]}
        />
      );
      break;

    case "asset_categories":
      ActiveComponent = () => (
        <SystemTable
          source="asset_categories"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
            {
              key: "owner_type",
              required: true,
              type: "select",
              selectData: ownerTypeData,
            },
          ]}
        />
      );
      break;

    case "asset_sub_categories":
      ActiveComponent = () => (
        <SystemTable
          source="asset_sub_categories"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
            {
              key: "parent_category_id",
              required: true,
              type: "formItem",
              listData: list,
              listDataId: "id",
              listDataName: "name",
              formItem: (
                <SettingsDataSelect
                  name="parent_category_id"
                  category="settings"
                  settingsdataName="system_tables/asset_categories"
                  hideLabel={true}
                  required={true}
                  // required={isAllowedFeature("accounting_tag")}
                  getPopupContainer={(trigger) => document.body}
                  style={{ margin: 0 }}
                />
              ),
            },
          ]}
        />
      );
      break;

    case "asset_statuses":
      ActiveComponent = () => (
        <SystemTable
          source="asset_statuses"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "description",
            },
            {
              key: "owner_type",
              required: true,
              type: "select",
              selectData: ownerTypeData,
            },
            { key: "initial", type: "checkbox" },
          ]}
        />
      );
      break;

    case "foreign_corporations":
      ActiveComponent = () => (
        <SystemTable
          source="foreign_corporations"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "contact_name",
            },
            {
              key: "contact_phone_number",
              type: "formItem",
              inputType: "phone",
              formItem: (
                <PhoneNumberItem
                  name="contact_phone_number"
                  category="settings"
                  hideLabel={true}
                />
              ),
            },
          ]}
        />
      );
      break;

    case "nursing_home":
      ActiveComponent = () => (
        <SystemTable
          source="nursing_home"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "number",
            },
            {
              key: "description",
            },
          ]}
        />
      );
      break;

    case "revaha_authorities":
      ActiveComponent = () => (
        <SystemTable
          source="revaha_authorities"
          initialSorter={"name"}
          built_in_non_editable={["name", "code"]}
          fields={[
            {
              key: "name",
              title: "local_authority",
              required: true,
              focused: true,
              sorter: true,
            },
            { key: "code", title: "local_authority_code" },
            { key: "contact" },
            { key: "description", title: "additional_details" },
          ]}
        />
      );
      break;

    case "crm_task_types":
      ActiveComponent = () => (
        <SystemTable
          source="crm_task_types"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            {
              key: "entity",
              required: true,
              type: "select",
              selectData: entityData,
            },
          ]}
          sub_table_props={{
            source: "crm_sub_task_types",
            initialSorter: "name",
            fields: [
              { key: "name", required: true, focused: true, sorter: true },
            ],
            identifier: "crm_task_type_id",
          }}
        />
      );
      break;

    default:
      ActiveComponent = () => (
        <SystemTable
          source="education"
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "description" },
          ]}
        />
      );
      break;
  }

  const items = [
    {
      name: "education",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "care_demands",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "patient_categories",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "patient_emergeycy_service_status",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },

    {
      name: "relative_types",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "nursing_home",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "departments",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "organization",
    },
    {
      name: "order_service_types",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "orders",
    },
    {
      name: "client_frame_symbol",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "orders",
    },
    {
      name: "client_tariff_symbol",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "orders",
    },
    {
      name: "order_close_reason",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "orders",
    },
    {
      name: "absence_reasons",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "foreign_corporations",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "company_types",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "organization",
    },
    {
      name: "insurance_companies",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "languages",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "monthly_transportation_cost",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "salary",
    },
    {
      name: "refund_reasons",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "accounting",
    },
    {
      name: "unpaid_hours_reasons",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "accounting",
    },
    {
      name: "daily_transportation_cost",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "salary",
    },
    {
      name: "religions",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "tasks_types",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "organization",
    },
    {
      name: "managed_gap_reasons",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "organization",
    },
    {
      name: "holidays",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "end_work_period_reason",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "courses",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "employees",
    },
    {
      name: "hospitalization",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "emergency_communication_ways",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "referrer",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "sub_referrer",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "patients",
    },
    {
      name: "report_categories",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "reports",
    },
    {
      name: "subprojects",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "organization",
    },
    {
      name: "branch_extensions",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "branches",
    },
    {
      name: "service_areas",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "branches",
    },
    {
      name: "branch_groups",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "branches",
    },
    {
      name: "client_category",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "clients",
    },
    {
      name: "asset_categories",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "assets",
    },
    {
      name: "asset_sub_categories",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "assets",
    },
    {
      name: "asset_statuses",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "assets",
    },
    {
      name: "revaha_authorities",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "orders",
    },
    {
      name: "crm_task_types",
      category: "settings",
      icon: <AuditOutlined />,
      sub_category: "crm",
    },
  ];

  const subCategories = {
    employees: <SolutionOutlined />,
    patients: <MedicineBoxOutlined />,
    orders: <DashboardOutlined />,
    salary: <DollarCircleOutlined />,
    accounting: <DollarCircleOutlined />,
    reports: <BarChartOutlined />,
    branches: <FlagOutlined />,
    clients: <RocketOutlined />,
    assets: <FilePdfOutlined />,
    organization: <SettingOutlined />,
    crm: <ContainerOutlined />,
  };

  const sortedItems = _.sortBy(items, [
    function (o) {
      return intl.formatMessage({
        id: `app.settings.${o.name}`,
      });
    },
  ]);

  const grouped = groupBy(sortedItems, (dt) => dt.sub_category);
  const sortedkeys = _.sortBy(Object.keys(grouped), [
    function (o) {
      return intl.formatMessage({
        id: `app.settings.${o}`,
      });
    },
  ]);

  return (
    <Layout style={{ background: "transparent" }}>
      <Spacer horizontal={true} smallMargin={true} />
      <ContentSider width={250}>
        <Menu
          style={{ width: 250 }}
          mode="vertical"
          onClick={onClick}
          items={sortedkeys.map((key) => ({
            label: intl.formatMessage({
              id: `app.settings.${key}`,
            }),
            key: key,
            icon: subCategories[key],
            selectedkeys: [menuKey],
            children: grouped[key].map((i) => ({
              label: intl.formatMessage({
                id: `app.settings.${i.name}`,
              }),
              key: i.name,
            })),
          }))}
        />
      </ContentSider>
      <Content style={{ minHeight: 280, flex: 1 }}>
        <Surface>
          {activekey === "system_tables" && <ActiveComponent />}
        </Surface>
      </Content>
    </Layout>
  );
};

SystemTables.propTypes = {
  mode: PropTypes.string,
};

export default SystemTables;
